<template>
  <v-container class="pessoas">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        main="Painel de notícias"
        icon="mdi-pencil-box-outline"
        sub="Categorias diversas"
        home="/noticias"
      />
      <Categoria />
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Categoria from '../categorias'
export default {
  name: 'Pessoas',
  components: { PageTitle, Categoria },
  data: () => ({

  })
}
</script>
